import { Box, DialogActions, DialogContent, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ActionButton from "../../components/Button/ActionButton";
import DialogComponent from "../../components/Dialog/Dialog";
import { semanticColors } from "../../utils/colors";
import { typography } from "../../utils/typography";

const messageSx = {
  ...typography.body.l,
  color: semanticColors.text.primary
};

/**
 * Confirms the request went out. Dismissing it leaves the screen, so there is
 * only one way on: the form behind it no longer describes anything pending.
 */
export default function PaymentRequestedDialog({
  open,
  onDismiss
}: {
  open: boolean;
  onDismiss: () => void;
}) {
  const { t } = useTranslation();

  return (
    <DialogComponent
      open={open}
      handleModal={onDismiss}
      headerTxt={t("requestPayment.successTitle")}
    >
      <DialogContent>
        <Typography sx={messageSx}>
          {t("requestPayment.successMessage")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Box display="flex" gap={1} p={1}>
          <ActionButton label={t("common.ok")} onClick={onDismiss} />
        </Box>
      </DialogActions>
    </DialogComponent>
  );
}
